var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"item"},[_c('box-list-item',{attrs:{"datas":_vm.item}}),_c('button-history-remove',{attrs:{"slug":_vm.item.slug}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }